
export default {
    name: 'meeting-lock',
    created() {
        this.model = 'Report.Meeting.Lock';
    },
    data() {
        return {
            show_edit: false,
            meeting:{},
            download_report:false,
            search_user:'',
            zcode:'123456',
            participants:[],
        }
    },
    computed:{
        emails(){
            let data = [];
            if (this.meeting.attendees) {
                try {
                    data = JSON.parse(this.meeting.attendees);
                } catch (e) {
                    console.log(e)
                }
            }
            return data;
        }
    },
    methods: {
        handleEdit(id) {
           this.$router.push({path:'/edit/'+id});
        },
        handleEditSubmit() {

        },
        makeRandomPassword(){
            let code = Math.round(900000 * Math.random() + 100000) + '';
            if (code.length > 6) code = code.substr(-6);
            this.$set(this, 'zcode', code);
        },
        coHost(row) {
            this.$api('Report.Meeting.Detail' + '.cohost', {id: this.meeting.id, user:row}, true).then(() => {
                this.$notice.success(('设置完成!'));
            });
        },
        handleLock(){
            const id = this.meeting.id;
            this.$api('Admin.ZoomRoom.Unlock', {id:id,lock:1}, 1).then(() => {
                this.$notice.success(('关闭完成!'));
            });
        },
        handleUnlock(){
            const id = this.meeting.id;
            this.$api('Admin.ZoomRoom.unlock',{id:id,lock:0},1).then(() => {
                this.$notice.success(('开启完成!'));
            });
        },
        handleMeetingReview(id){
            let vm = this;
            this.$api('Report.Meeting.Detail' + '.Get', {id: id, review: true, in_meeting:true,}, true).then(res => {
                vm.meeting = res.data.data;
                vm.view_mode = true;
                this.$set(this, 'zcode', vm.meeting.zcode);
            });
        },
        handleResentCreationNotice(){
            const id = this.meeting.id;
            this.$api('Admin.Meeting.Resend.MailCreationNotice', {id: id}, true).then(() => {
                this.$notice.success(('已发送!'));
            });
        },
        changeHostPassword(){
            console.log(this.zcode,this.zcode.length);
            if (this.zcode.length !== 6) {
                this.$notice.error('请输入6位主持密码:' + this.zcode + ' (' + this.zcode.length + ')');
                return;
            }
            if (this.zcode === this.meeting.zcode) {
                this.$notice.error('请输入与原来密码不同的的6位数字');
                return;
            }
            this.$affirm('确定要修改主持密码吗？').then(() => {
                this.$api('Query.Rebuild.Zcode', {id: this.meeting.id, zcode:this.zcode}, true).then(() => {
                    this.$notice.success(('主持密码已更改!'));
                    this.handleMeetingReview(this.meeting.id);
                });
            })
        }
    }
}
